import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ErrorPage } from "./pages/errorpage";
import { WinepageScreen } from "./pages/winepage";
import { Layout } from "./components/common/Layout";
import { HomepageScreen } from "./pages/homepage";

const router = createBrowserRouter([
  {
    path: "/*",
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <HomepageScreen />,
      },
      {
        path: "wines/:id/",
        element: <WinepageScreen />,
      },
      {
        path: "*",
        element: <ErrorPage />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
